
export class RistoranteTilby {
    ristoranteId: string;
    status: string;
    token: string;
    channelName: string;
    departmentId: number;
    environmentId: string;
    lastRevenueDownload: string;

    constructor() {
        this.ristoranteId = "";
        this.status = "";
        this.token = "";
        this.channelName = "";
        this.departmentId = 0;
        this.environmentId = "";
        this.lastRevenueDownload = "";
    }

    static fromJson(json: any): RistoranteTilby {
        let result = new RistoranteTilby();
        result.ristoranteId = json.ristoranteId;
        result.status = json.nome;
        result.token = json.token;
        result.channelName = json.channelName;
        result.departmentId = json.departmentId;
        result.environmentId = json.environmentId;
        result.lastRevenueDownload = json.lastRevenueDownload;
        return result;
    }
}